import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type SubjectFormArgs = {
	title: string;
};

/** The title of a dossier to create; it matches the server's bounds (required, 180 characters). */
@ValidatedClass()
class SubjectFormData extends AbstractValidatedClass<SubjectFormArgs> {
	@constraint(Joi.string().max(180), () => '180 caractères au plus.')
	@constraint(Joi.string().trim().required(), () => 'Ce champ est obligatoire.')
	public readonly title: string;

	constructor(data: SubjectFormArgs) {
		super(data);
		this.title = data.title;
		Object.freeze(this);
	}

	static createEmpty(): SubjectFormData {
		return new SubjectFormData({ title: '' });
	}

	setTitle(title: string): this {
		return this.cloneWith({ title } as Partial<SubjectFormArgs>);
	}
}

export default SubjectFormData;
